import React, { type ComponentType } from 'react';
import withInjectedProps from '@atlassian/jira-common-util-with-injected-props/src/index.tsx';
import { SubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/sub-product-updater/index.tsx';
import Boards from './view.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Updater: ComponentType<Record<any, any>> = () => <SubProductUpdater subProduct="platform" />;

export default withInjectedProps(Boards, {
	Updater,
});
